import React from "react";
import Ink from "react-ink";
import nextBlueIcon from "../../assets/icons/Conti_blue.png";
import nextWhiteIcon from "../../assets/icons/Conti_white.png";

export default function StepTab({
  text,
  onClick = function() {},
  active = false
}) {
  return (
    <div
      className={`step-tab-container ${active &&
        "step-tab-container-active"} shadow`}
      onClick={onClick}
    >
      <p className="text-center flex1">{text}</p>
      <img alt="icon" src={active ? nextWhiteIcon : nextBlueIcon} width="20px" />
      <Ink />
    </div>
  );
}
